import { createStore, applyMiddleware, compose } from "redux";
import { createEpicMiddleware } from "redux-observable";
import rootReducer, { RootState } from "./rootReducer";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "react-router-redux";
import { connectRouter } from "connected-react-router";
import rootEpic from "./rootEpic";
import { RootAction } from "./rootAction";
import { ApiClient } from "../lib/api";

const composeEnhancers =
  (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const history = createBrowserHistory();

const epicMiddleware = createEpicMiddleware<
  RootAction,
  RootAction,
  RootState,
  ApiClient
>({ dependencies: new ApiClient() });

function configureStore(initialState?: {}) {
  // configure middlewares
  const middlewares = [routerMiddleware(history), epicMiddleware];
  // compose enhancers
  const enhancer = composeEnhancers(applyMiddleware(...middlewares));
  // create store
  return createStore(
    connectRouter(history)(rootReducer),
    initialState!,
    enhancer
  );
};

// pass an optional param to rehydrate state on app start
const store = configureStore();

epicMiddleware.run(rootEpic);

// export store singleton instance
export default store;
